import Home from './components/home/Home.vue'
import TeamMember from './components/team-member/TeamMember.vue'
import Twitter from './components/twitter/TwitterPage.vue'
import RadioStream from './components/radio-stream/RadioStream.vue'
import MobileRadioStream from './components/radio-stream/MobileRadioStream.vue'
import TextContent from './components/text-content/TextContent.vue'
import RssFeed from './components/rssFeed/RssFeed.vue'
import RssFeedDetail from './components/rssFeed/RssFeedDetail.vue'
import TextContentDetail from './components/text-content/TextContentDetail.vue'
import termcondtion from './components/shared/termcondtion.vue'
import News from './components/news/News.vue'
import NewsDetail from './components/news/NewsDetail.vue'
import Event from './components/event/Event.vue'
import EventDetail from './components/event/EventDetail.vue'
import POI from './components/poi/POI.vue'
import POIDetail from './components/poi/POIDetail.vue'
import CustomForm from './components/custom-form/CustomForm.vue'
import ImageGallery from './components/image-gallery/ImageGallery.vue'
import ImageGalleryDetail from './components/image-gallery/ImageGalleryDetail.vue'
import Youtube from './components/youtube/Youtube.vue'
// import YoutubeDetail from './components/youtube/YoutubeDetailN.vue'
// import YoutubeVideo from './components/youtube/YoutubeVideo.vue'
import Website from './components/website/website.vue'
import Instagram from './components/instagram/InstagramNew.vue'
import Facebook from './components/Facebook/FacebookNew.vue'

import ChatMain from './components/chat/ChatMain.vue'
import Pdf from './components/pdf/Pdf.vue'
import CustomCode from './components/custom-code/CustomCode.vue'
import NotFound from './components/shared/NotFound.vue'
import Terms from './components/shared/Terms.vue'
import demo from './components/shared/demo.vue'
import lockScreen from './components/shared/lockScreen.vue'
import { mutationNames } from '@/store/storeKeysettings'

import * as Helper from '@/modules/helper'
import { isPhoneGap } from '@/modules/util/util'
import { routeEvent } from '@/store/store'
import store from '@/store/store'

const on = routeEvent

export default [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/home-view',
    component: Home,
    on
  },
  {
    path: '/home',
    component: Home,
    on
  },
  {
    path: '/team-view/:Id',
    async: async function  (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      if (routeTo.query.isUnLock) {
        resolve({ component: TeamMember })
      } else {
        resolve({ component: lock ? lockScreen : TeamMember })
      }
    },
    on
  },
  {
    path: '/twitter-view/:Id',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Requested route
      let lock = Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      let SubscriptionModuleId = routeTo.params.Id
      let TwitterModule = store.getters.MainMenuList.filter(m => m.Id === parseInt(SubscriptionModuleId))
      if (SubscriptionModuleId) {
        if (!Helper.IsUserActionAllow()) {
          console.log('13')
          resolve({ component: Twitter })
        } else {
          if(!isPhoneGap()) {
            console.log('1')
            window.open(TwitterModule[0].LinkedUrl)
          } else {
            console.log('2')
            Helper.loadTwitterData(SubscriptionModuleId, store.getters.DesignSettings.AppThemeColor, store.getters.DesignSettings.AppThemeFontColor)
            reject()
          }
        }
      }
    },
    on
  },
  {
    path: '/website-view/:Id',
   async: function (routeTo, routeFrom, resolve, reject) {
    // Requested route
    let SubscriptionModuleId = routeTo.params.Id
    let WebModule = store.getters.MainMenuList.filter(m => m.Id === parseInt(SubscriptionModuleId))
    if (SubscriptionModuleId) {
      if (!Helper.IsUserActionAllow()) {
        resolve({ component: Website })
      } else {
        if(!isPhoneGap()) {
          window.open(WebModule[0].LinkedUrl)
        } else {
        Helper.loadWebsiteModule(SubscriptionModuleId, store.getters.DesignSettings.AppThemeColor, store.getters.DesignSettings.AppThemeFontColor)
        reject()
        }
      }
    }
  },
  on
  },
  {
    path: '/instagram-view/:Id',
   async: function (routeTo, routeFrom, resolve, reject) {
    // Requested route
    let SubscriptionModuleId = routeTo.params.Id
    let InstaModule = store.getters.MainMenuList.filter(m => m.Id === parseInt(SubscriptionModuleId))
    if (SubscriptionModuleId) {
      if (!Helper.IsUserActionAllow()) {
        resolve({ component: Instagram })
      } else {
        if(!isPhoneGap()) {
          window.open(InstaModule[0].LinkedUrl)
        } else {
          Helper.loadInstagramModule(SubscriptionModuleId, store.getters.DesignSettings.AppThemeColor, store.getters.DesignSettings.AppThemeFontColor)
          reject()
        }
      }
    }
  },
  on
  },
  {
    path: '/facebook-view/:Id',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Requested route
      let lock = Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      let SubscriptionModuleId = routeTo.params.Id
      let FBModule = store.getters.MainMenuList.filter(m => m.Id === parseInt(SubscriptionModuleId))
      if (SubscriptionModuleId) {
        if (!Helper.IsUserActionAllow()) {
          resolve({ component: Facebook })
        } else {
          if(!isPhoneGap()) {
            window.open(FBModule[0].LinkedUrl)
          } else {
            Helper.loadFacebookModule(SubscriptionModuleId, store.getters.DesignSettings.AppThemeColor, store.getters.DesignSettings.AppThemeFontColor)
            reject()
          }
        }
      }
    },
    on
  },
  // {
  //   path: '/facebook-view-detail/:Id/:postid',
  //   component: FacebookDetail,
  //   on
  // },
  {
    path: '/radio-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      // console.log('radio', lock)
      if (routeTo.query.isUnLock) {
        resolve({ component: isPhoneGap() ? MobileRadioStream : RadioStream })
      } else {
        resolve({ component: lock ? lockScreen : isPhoneGap() ? MobileRadioStream : RadioStream })
      }
    },
    // component: isPhoneGap() ? MobileRadioStream : RadioStream,
    on
  },
  {
    path: '/text-content-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      // console.log('lock', lock)
      if (routeTo.query.isUnLock) {
        resolve({ component: TextContent })
      } else {
        resolve({ component: lock ? lockScreen : TextContent })
      }
    },
    on
  },
  {
    path: '/text-content-detail-view/:Id/:ContentId',
    component: TextContentDetail,
    on
  },
  {
    path: '/news-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      // console.log('lock', lock)
      if (routeTo.query.isUnLock) {
        resolve({ component: News })
      } else {
        resolve({ component: lock ? lockScreen : News })
      }
    },
    // component: News,
    on
  },
  {
    path: '/news-detail-view/:Id/:NewsId',
    component: NewsDetail,
    on
  },
  {
    path: '/event-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      // console.log('lock', lock)
      if (routeTo.query.isUnLock) {
        resolve({ component: Event })
      } else {
        resolve({ component: lock ? lockScreen : Event })
      }
    },
    // component: Event,
    on
  },
  {
    path: '/event-detail-view/:Id/:EventId',
    component: EventDetail,
    on
  },
  {
    path: '/rssfeed-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      if (routeTo.query.isUnLock) {
        resolve({ component: RssFeed })
      } else {
        resolve({ component: lock ? lockScreen : RssFeed })
      }
    },
    // component: RssFeed,
    on
  },
  {
    path: '/rss-detail-view/:Id/:feedid',
    component: RssFeedDetail,
    on
  },
  {
    path: '/termcondtion',
    name: 'termcondtion',
    component: termcondtion,
    },
  {
    path: '/poi-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      if (routeTo.query.isUnLock) {
        resolve({ component: POI })
      } else {
        resolve({ component: lock ? lockScreen : POI })
      }
    },
    // component: POI,
    on
  },
  {
    path: '/poi-detail-view/:Id/:ContentId',
    component: POIDetail,
    on
  },
  {
    path: '/custom-form-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      // console.log('lock', lock)
      if (routeTo.query.isUnLock) {
        resolve({ component: CustomForm })
      } else {
        resolve({ component: lock ? lockScreen : CustomForm })
      }
    },
    // component: CustomForm,
    on
  },
  {
    path: '/image-gallery-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      if (routeTo.query.isUnLock) {
        resolve({ component: ImageGallery })
      } else {
        resolve({ component: lock ? lockScreen : ImageGallery })
      }
    },
    // component: ImageGallery,
    on
  },
  {
    path: '/image-album-view/:Id/:AlbumId',
    component: ImageGalleryDetail,
    on
  },
  {
    path: '/youtube-view/:Id',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Requested route
      let lock = Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      let SubscriptionModuleId = routeTo.params.Id
      let YouTubeModule = store.getters.MainMenuList.filter(m => m.Id === parseInt(SubscriptionModuleId))
      console.log('YouTubeModule', YouTubeModule)
      if (SubscriptionModuleId) {
        if (!Helper.IsUserActionAllow()) {
          resolve({ component: Youtube })
        } else {
          if(!isPhoneGap()) {
            window.open(YouTubeModule[0].LinkedUrl)
          } else {
            Helper.loadYoutubeModule(SubscriptionModuleId, store.getters.DesignSettings.AppThemeColor, store.getters.DesignSettings.AppThemeFontColor)
            reject()
          }
        }
      }
    },
    on
  },
  // {
  //   path: '/youtube-view/:Id',
  //   async: async function (routeTo, routeFrom, resolve, reject) {
  //     let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
  //     if (routeTo.query.isUnLock) {
  //       resolve({ component: Youtube })
  //     } else {
  //       resolve({ component: lock ? lockScreen : Youtube })
  //     }
  //   },
  //   // component: Youtube,
  //   on
  // },
  {
    path: '/chat-view/:SubscriptionModuleId',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.SubscriptionModuleId)
      if (routeTo.query.isUnLock) {
        resolve({ component: ChatMain })
      } else {
        resolve({ component: lock ? lockScreen : ChatMain })
      }
    },
    // component: ChatMain,
    on
  },
  {
    path: '/chat-view/:SubscriptionModuleId/:ChannelId',
    component: ChatMain,
    on
  },
  {
    path: '/custom-code-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      if (routeTo.query.isUnLock) {
        resolve({ component: CustomCode })
      } else {
        resolve({ component: lock ? lockScreen : CustomCode })
      }
    },
    // component: CustomCode,
    on
  },
  {
    path: '/pdf-view/:Id',
    async: async function (routeTo, routeFrom, resolve, reject) {
      let lock = await Helper.IsAccessLockedTrue(store.getters, routeTo.params.Id)
      if (routeTo.query.isUnLock) {
        resolve({ component: Pdf })
      } else {
        resolve({ component: lock ? lockScreen : Pdf })
      }
    },
    // component: Pdf,
    on
  },
  {
    path: '/terms',
    component: Terms,
    on
  },
  {
    path: '(.*)',
    // component: NotFound,
    async: function (routeTo, routeFrom, resolve, reject) {
      let path = routeTo.path.replace(`${routeFrom.path}/`, '').replace('/', '//')
      if (path.indexOf('http') === 0) {
        Helper.showURL(path, store.getters.DesignSettings.AppThemeColor, store.getters.DesignSettings.AppThemeFontColor)
        reject()
      } else {
        resolve({
          component: NotFound
        })
      }
    }
  },
];



// WEBPACK FOOTER //
// ./src/routes.js